

// A simple glass-of-sangria icon: tulip-shaped glass with red liquid + a fruit slice
export default function SangriaIcon({ size = 22, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      {/* glass body (outline) */}
      <path
        d="M8 4 H24 C24 11 22 16 16 16 C10 16 8 11 8 4 Z"
        fill="rgba(255,255,255,0.18)"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      {/* sangria liquid */}
      <path
        d="M9.6 7 H22.4 C22 12 20.4 14.4 16 14.4 C11.6 14.4 10 12 9.6 7 Z"
        fill="#b21e2e"
      />
      {/* citrus slice on the rim */}
      <circle cx="21.5" cy="6" r="2.2" fill="#f4a521" stroke="#7a4a06" strokeWidth="0.6" />
      <path
        d="M21.5 3.8 L21.5 8.2 M19.3 6 L23.7 6 M19.95 4.45 L23.05 7.55 M19.95 7.55 L23.05 4.45"
        stroke="#f7d27a"
        strokeWidth="0.55"
        strokeLinecap="round"
      />
      {/* stem */}
      <line x1="16" y1="16" x2="16" y2="25" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      {/* base */}
      <line x1="10" y1="26.5" x2="22" y2="26.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      {/* a couple of bubbles */}
      <circle cx="13.4" cy="10.5" r="0.55" fill="rgba(255,255,255,0.7)" />
      <circle cx="15.2" cy="12.3" r="0.4"  fill="rgba(255,255,255,0.6)" />
    </svg>
  );
}
